import { useCallback, useContext } from 'react';
import ModalsContext from './ModalsContext';

var useModalState = function useModalState(id) {
  var _a = useContext(ModalsContext),
      openState = _a.openState,
      onChangeOpenState = _a.onChangeOpenState;

  var handleChangeOpen = useCallback(function (open) {
    if (id && onChangeOpenState) {
      onChangeOpenState(id, open);
    }
  }, [id, onChangeOpenState]);
  var open = id && openState && onChangeOpenState ? openState[id] : undefined;
  return {
    open: open,
    onChangeOpen: open != null ? handleChangeOpen : undefined
  };
};

export default useModalState;